import { Link, Outlet } from "react-router";
import { SignedIn, SignedOut } from "@clerk/clerk-react";
import { Button } from "@/components/ui/button";
import { Plane } from "lucide-react";

const MarketingLayout = () => {
  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container mx-auto flex h-14 items-center justify-between px-4 sm:px-6 lg:px-8">
          <Link to="/" className="flex items-center gap-2">
            <Plane className="h-5 w-5" />
            <span className="text-xl font-bold tracking-tight">Travel API</span>
          </Link>

          <nav className="flex items-center gap-4">
            <Link to="/docs" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              Docs
            </Link>
            <a href="#pricing" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
              Pricing
            </a>
            <SignedIn>
              <Button asChild size="sm">
                <Link to="/dashboard">Dashboard</Link>
              </Button>
            </SignedIn>
            <SignedOut>
              <Button variant="ghost" asChild size="sm">
                <Link to="/sign-in">Sign In</Link>
              </Button>
              <Button asChild size="sm">
                <Link to="/sign-up">Get Started</Link>
              </Button>
            </SignedOut>
          </nav>
        </div>
      </header>

      <Outlet />
    </div>
  );
};

export default MarketingLayout;
